import { NamedIconsGroupType } from '../types/types';
import {
    formalitiesIcons,
    modelIcons,
    invoiceNamedIcons,
    generalNamedIcons,
    signNamedIcons,
    logtimelineNamedIcons,
    fileNamedIcons,
    inputIcons,
    userActionIcons,
    statusIcons,
    alertNamedIcons,
    formNamedIcons,
    publicationNamedIcons,
    tableNamedIcons,
} from './icons';

export const namedIconsGroups: NamedIconsGroupType[] = [
    {
        name: 'general',
        displayName: 'Icônes générales',
        icons: generalNamedIcons,
    },
    {
        name: 'status',
        displayName: 'Icônes de statut',
        icons: statusIcons,
    },
    {
        name: 'alert',
        displayName: 'Icônes des alertes',
        icons: alertNamedIcons,
    },
    {
        name: 'formalities',
        displayName: 'Icônes Formalités',
        icons: formalitiesIcons,
    },
    {
        name: 'publications',
        displayName: 'Icônes Publications',
        icons: publicationNamedIcons,
    },
    {
        name: 'files',
        displayName: 'Icônes fichiers',
        icons: fileNamedIcons,
    },
    {
        name: 'invoices',
        displayName: 'Icônes factures',
        icons: invoiceNamedIcons,
    },
    {
        name: 'sign',
        displayName: 'Icônes signatures',
        icons: signNamedIcons,
    },
    {
        name: 'timeline',
        displayName: 'Icônes timelines',
        icons: logtimelineNamedIcons,
    },
    {
        name: 'inputs',
        displayName: 'Icônes champs utilisateur',
        icons: inputIcons,
    },
    {
        name: 'models',
        displayName: 'Modèles API',
        icons: modelIcons,
    },
    {
        name: 'userActions',
        displayName: 'Icônes actions utilisateur',
        icons: userActionIcons,
    },
    {
        name: 'form',
        displayName: 'Icônes des formulaires',
        icons: formNamedIcons,
    },
    {
        name: 'table',
        displayName: 'Icones des tableaux',
        icons: tableNamedIcons,
    },
];

export const namedIconsTree: unknown = namedIconsGroups.reduce(
    (acc: Record<string, unknown>, current) => {
        acc[current.name] = current.icons.reduce((acc2: Record<string, unknown>, current2) => {
            acc2[current2.name] = current2;
            return acc2;
        }, {});
        return acc;
    },
    {},
);

export type NamedIconsTreeType = typeof namedIconsTree;
